import React, { createContext, useContext, useState, useCallback } from 'react';
import { formatDisplayName } from '../lib/formatName';

const ImpersonationContext = createContext(null);

export function ImpersonationProvider({ children }) {
  const [impersonatedUser, setImpersonatedUser] = useState(() => {
    try {
      const saved = sessionStorage.getItem('impersonated_user');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const startImpersonation = useCallback((user) => {
    const userData = {
      id: user.id,
      username: user.username,
      email: user.email,
      name: formatDisplayName(user.first_name, user.last_name) || user.username,
      role: user.role,
      client_id: user.client_id,
      permissions: user.permissions || [],
    };
    setImpersonatedUser(userData);
    sessionStorage.setItem('impersonated_user', JSON.stringify(userData));
  }, []);

  const stopImpersonation = useCallback(() => {
    setImpersonatedUser(null);
    sessionStorage.removeItem('impersonated_user');
  }, []);

  const isImpersonating = !!impersonatedUser;

  return (
    <ImpersonationContext.Provider value={{
      impersonatedUser,
      isImpersonating,
      startImpersonation,
      stopImpersonation,
    }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export function useImpersonation() {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error('useImpersonation must be used within ImpersonationProvider');
  }
  return context;
}

export default ImpersonationContext;
